var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldMoney4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 3.5c-3 0-5 1.5-5 5v7c0 3.5 2 5 5 5h10c3 0 5-1.5 5-5v-7c0-3.5-2-5-5-5H7zm0 1.75h1.5c.41 0 .75.34.75.75s-.34.75-.75.75H7c-.96 0-1.75.79-1.75 1.75V10c0 .41-.34.75-.75.75s-.75-.34-.75-.75V8.5c0-1.79 1.46-3.25 3.25-3.25zm0 13.5c-1.79 0-3.25-1.46-3.25-3.25V14c0-.41.34-.75.75-.75s.75.34.75.75v1.5c0 .96.79 1.75 1.75 1.75h1.5c.41 0 .75.34.75.75s-.34.75-.75.75H7zM9 12c0-1.66 1.34-3 3-3s3 1.34 3 3-1.34 3-3 3-3-1.34-3-3zm8 6.75h-1.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H17c.96 0 1.75-.79 1.75-1.75V14c0-.41.34-.75.75-.75s.75.34.75.75v1.5c0 1.79-1.46 3.25-3.25 3.25zm2.5-8c-.41 0-.75-.34-.75-.75V8.5c0-.96-.79-1.75-1.75-1.75h-1.5c-.41 0-.75-.34-.75-.75s.34-.75.75-.75H17c1.79 0 3.25 1.46 3.25 3.25V10c0 .41-.34.75-.75.75z",
    fill: "{props.color}",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldMoney4);
export default __webpack_public_path__ + "static/media/vuesax-bold-money-4.8b7ce47df651b4949b537c7eefb55999.svg";
export { ForwardRef as ReactComponent };